// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3khfP","importantInfo":"styles_importantInfo__1QFdf"};